var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "page",
      staticClass: "page",
      attrs: {
        "element-loading-text": "加载中...",
        "element-loading-background": "rgba(0, 0, 0, 0.3)",
      },
    },
    [
      _c("div", { ref: "search", staticClass: "page-search" }, [
        _c(
          "div",
          { staticClass: "search-row" },
          [
            _c("el-date-picker", {
              attrs: {
                type: "date",
                placeholder: "开始日期",
                "value-format": "yyyy-MM-dd",
                "picker-options": _vm.startDatePickerOptions,
              },
              model: {
                value: _vm.searchForm.invoiceStartDate,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "invoiceStartDate", $$v)
                },
                expression: "searchForm.invoiceStartDate",
              },
            }),
            _c("el-date-picker", {
              attrs: {
                type: "date",
                placeholder: "结束日期",
                "value-format": "yyyy-MM-dd",
                "picker-options": _vm.endDatePickerOptions,
              },
              model: {
                value: _vm.searchForm.invoiceEndDate,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "invoiceEndDate", $$v)
                },
                expression: "searchForm.invoiceEndDate",
              },
            }),
            _c("el-input", {
              attrs: { placeholder: "请输入客户编码" },
              model: {
                value: _vm.searchForm.customerCode,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "customerCode", $$v)
                },
                expression: "searchForm.customerCode",
              },
            }),
            _c("el-input", {
              attrs: { placeholder: "请输入客户名称" },
              model: {
                value: _vm.searchForm.customerName,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "customerName", $$v)
                },
                expression: "searchForm.customerName",
              },
            }),
            _c("el-input", {
              staticStyle: { "margin-right": "0" },
              attrs: { placeholder: "请输入分公司编码" },
              model: {
                value: _vm.searchForm.branchCompanyCode,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "branchCompanyCode", $$v)
                },
                expression: "searchForm.branchCompanyCode",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-row" },
          [
            _c("el-input", {
              attrs: { placeholder: "请输入分公司名称" },
              model: {
                value: _vm.searchForm.branchCompanyName,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "branchCompanyName", $$v)
                },
                expression: "searchForm.branchCompanyName",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "search-row",
          staticStyle: { "justify-content": "space-between" },
        },
        [
          _c(
            "div",
            [
              _c(
                "span",
                { staticStyle: { "font-weight": "bold", "font-size": "14px" } },
                [_vm._v("动态模块展示选择：")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "default" },
                  on: { click: _vm.openModuleDialog },
                },
                [_vm._v("选择模块")]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-weight": "bold",
                    "font-size": "14px",
                    "margin-left": "20px",
                  },
                },
                [_vm._v("动态参数展示选择：")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "default" },
                  on: { click: _vm.openParamDialog },
                },
                [_vm._v("选择参数")]
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSearch } },
                [_vm._v("查询")]
              ),
              _c("el-button", { on: { click: _vm.handleReset } }, [
                _vm._v("重置"),
              ]),
              _c("el-button", { on: { click: _vm.handleExport } }, [
                _vm._v("导出"),
              ]),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "page-table" },
        [
          _c(
            "vxe-table",
            {
              key: _vm.tableKey,
              ref: "xTable",
              attrs: {
                border: "",
                "show-overflow": "",
                size: "mini",
                resizable: "",
                data: _vm.tableData,
                "auto-resize": true,
                "fixed-header": true,
                height: _vm.tableHeight,
                "show-footer": true,
                "footer-method": _vm.footerMethod,
                "span-method": _vm.spanMethod,
              },
            },
            [
              _c("vxe-column", {
                attrs: { field: "dateScope", width: "100", title: "统计期间" },
              }),
              _c("vxe-column", {
                attrs: { field: "companyName", width: "100", title: "分公司" },
              }),
              _c("vxe-column", {
                attrs: { field: "customerName", width: "100", title: "经销商" },
              }),
              _c(
                "vxe-colgroup",
                {
                  attrs: {
                    title: "销售额",
                    field: "group1",
                    "header-align": "center",
                  },
                },
                [
                  _c("vxe-column", {
                    attrs: {
                      field: "companySaleAmount",
                      width: "100",
                      title: "公司销售",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "sellThroughAmount",
                      width: "100",
                      title: "平台动销",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "companySaleSellThroughAmount",
                      width: "100",
                      title: "小计",
                    },
                  }),
                ],
                1
              ),
              _vm.showModule("group2")
                ? _c(
                    "vxe-colgroup",
                    {
                      attrs: {
                        title: "总投入",
                        field: "group2",
                        "header-align": "center",
                      },
                    },
                    [
                      _vm.showColumn("zltrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "zltrAmount",
                              width: "100",
                              title: "战略投入",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("gstctrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "gstctrAmount",
                              width: "100",
                              title: "公司统筹投入",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("scjctrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "scjctrAmount",
                              width: "100",
                              title: "市场基础投入",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("zxtrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "zxtrAmount",
                              width: "100",
                              title: "专项投入",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("gstctrzyAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "gstctrzyAmount",
                              width: "100",
                              title: "公司统筹投入(专用)",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("blAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "blAmount",
                              width: "100",
                              title: "B类费用",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("zrcsgjAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "zrcsgjAmount",
                              width: "100",
                              title: "折让/厂商共建费用",
                            },
                          })
                        : _vm._e(),
                      _c("vxe-column", {
                        attrs: {
                          field: "trTotalAmount",
                          width: "100",
                          title: "小计",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showModule("group3")
                ? _c(
                    "vxe-colgroup",
                    {
                      attrs: {
                        title: "汇总",
                        field: "group3",
                        "header-align": "center",
                      },
                    },
                    [
                      _c("vxe-column", {
                        attrs: {
                          field: "group3_firstSubjectName",
                          width: "100",
                          title: "一级科目",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "group3_secondSubjectName",
                          width: "100",
                          title: "二级科目",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "group3_schemeAmout",
                          width: "100",
                          title: "方案规划金额",
                        },
                      }),
                      _c(
                        "vxe-colgroup",
                        {
                          attrs: {
                            title: "申请金额",
                            field: "group3-1",
                            "header-align": "center",
                          },
                        },
                        [
                          _vm.showColumn("zltrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group3_zltrApplyAmount",
                                  width: "100",
                                  title: "战略投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("gstctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group3_gstctrApplyAmount",
                                  width: "100",
                                  title: "公司统筹投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("scjctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group3_scjctrApplyAmount",
                                  width: "100",
                                  title: "市场基础投入",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group3_zxtrApplyAmount",
                              width: "100",
                              title: "专项投入",
                            },
                          }),
                          _vm.showColumn("gstctrzyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group3_gstctrzyApplyAmount",
                                  width: "100",
                                  title: "公司统筹投入(专用)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("blAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group3_blApplyAmount",
                                  width: "100",
                                  title: "B类费用",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("zrcsgjAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group3_zrcsgjApplyAmount",
                                  width: "100",
                                  title: "折让/厂商共建费用",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group3_trTotalApplyAmount",
                              width: "100",
                              title: "小计",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group3_applyRate",
                              width: "100",
                              title: "占比",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group3_ztApplyAmount",
                              width: "100",
                              title: "直投金额",
                            },
                          }),
                          _vm.showColumn("ztApplyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group3_jxsdfApplyAmount",
                                  width: "100",
                                  title: "经销商垫付金额",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("applyInvestRate")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group3_applyInvestRate",
                                  width: "100",
                                  title: "投入比(申请/投入)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("applyExecutionRate")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group3_applyExecutionRate",
                                  width: "100",
                                  title: "执行率(申请/规划)",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "vxe-colgroup",
                        {
                          attrs: {
                            title: "核销金额",
                            field: "group3-2",
                            "header-align": "center",
                          },
                        },
                        [
                          _vm.showColumn("zltrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group3_zltrAuditAmount",
                                  width: "100",
                                  title: "战略投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("gstctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group3_gstctrAuditAmount",
                                  width: "100",
                                  title: "公司统筹投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("scjctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group3_scjctrAuditAmount",
                                  width: "100",
                                  title: "市场基础投入",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group3_zxtrAuditAmount",
                              width: "100",
                              title: "专项投入",
                            },
                          }),
                          _vm.showColumn("gstctrzyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group3_gstctrzyAuditAmount",
                                  width: "100",
                                  title: "公司统筹投入(专用)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("blAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group3_blAuditAmount",
                                  width: "100",
                                  title: "B类费用",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("zrcsgjAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group3_zrcsgjAuditAmount",
                                  width: "100",
                                  title: "折让/厂商共建费用",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group3_trTotalAuditAmount",
                              width: "100",
                              title: "小计",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group3_ztAuditAmount",
                              width: "100",
                              title: "直投金额",
                            },
                          }),
                          _vm.showColumn("ztApplyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group3_jxsdfAuditAmount",
                                  width: "100",
                                  title: "经销商垫付金额",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showModule("group4")
                ? _c(
                    "vxe-colgroup",
                    {
                      attrs: {
                        title: "红西凤投入",
                        field: "group4",
                        "header-align": "center",
                      },
                    },
                    [
                      _vm.showColumn("zltrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group4_zltrAmount",
                              width: "100",
                              title: "战略投入",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("gstctrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group4_gstctrAmount",
                              width: "100",
                              title: "公司统筹投入",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("scjctrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group4_scjctrAmount",
                              width: "100",
                              title: "市场基础投入",
                            },
                          })
                        : _vm._e(),
                      _c("vxe-column", {
                        attrs: {
                          field: "group4_zxtrAmount",
                          width: "100",
                          title: "专项投入",
                        },
                      }),
                      _vm.showColumn("gstctrzyAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group4_gstctrzyAmount",
                              width: "100",
                              title: "公司统筹投入(专用)",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("blAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group4_blAmount",
                              width: "100",
                              title: "B类费用",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("zrcsgjAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group4_zrcsgjAmount",
                              width: "100",
                              title: "折让/厂商共建费用",
                            },
                          })
                        : _vm._e(),
                      _c("vxe-column", {
                        attrs: {
                          field: "group4_trTotalAmount",
                          width: "100",
                          title: "小计",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showModule("group5")
                ? _c(
                    "vxe-colgroup",
                    {
                      attrs: {
                        title: "红西凤系列",
                        field: "group5",
                        "header-align": "center",
                      },
                    },
                    [
                      _c("vxe-column", {
                        attrs: {
                          field: "group5_firstSubjectName",
                          width: "100",
                          title: "一级科目",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "group5_secondSubjectName",
                          width: "100",
                          title: "二级科目",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "group5_schemeAmout",
                          width: "100",
                          title: "方案规划金额",
                        },
                      }),
                      _c(
                        "vxe-colgroup",
                        {
                          attrs: {
                            title: "申请金额",
                            field: "group5-1",
                            "header-align": "center",
                          },
                        },
                        [
                          _vm.showColumn("zltrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group5_zltrApplyAmount",
                                  width: "100",
                                  title: "战略投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("gstctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group5_gstctrApplyAmount",
                                  width: "100",
                                  title: "公司统筹投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("scjctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group5_scjctrApplyAmount",
                                  width: "100",
                                  title: "市场基础投入",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group5_zxtrApplyAmount",
                              width: "100",
                              title: "专项投入",
                            },
                          }),
                          _vm.showColumn("gstctrzyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group5_gstctrzyApplyAmount",
                                  width: "100",
                                  title: "公司统筹投入(专用)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("blAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group5_blApplyAmount",
                                  width: "100",
                                  title: "B类费用",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("zrcsgjAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group5_zrcsgjApplyAmount",
                                  width: "100",
                                  title: "折让/厂商共建费用",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group5_trTotalApplyAmount",
                              width: "100",
                              title: "小计",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group5_applyRate",
                              width: "100",
                              title: "占比",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group5_ztApplyAmount",
                              width: "100",
                              title: "直投金额",
                            },
                          }),
                          _vm.showColumn("ztApplyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group5_jxsdfApplyAmount",
                                  width: "100",
                                  title: "经销商垫付金额",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("applyInvestRate")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group5_applyInvestRate",
                                  width: "100",
                                  title: "投入比(申请/投入)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("applyExecutionRate")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group5_applyExecutionRate",
                                  width: "100",
                                  title: "执行率(申请/规划)",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "vxe-colgroup",
                        {
                          attrs: {
                            title: "核销金额",
                            field: "group5-2",
                            "header-align": "center",
                          },
                        },
                        [
                          _vm.showColumn("zltrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group5_zltrAuditAmount",
                                  width: "100",
                                  title: "战略投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("gstctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group5_gstctrAuditAmount",
                                  width: "100",
                                  title: "公司统筹投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("scjctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group5_scjctrAuditAmount",
                                  width: "100",
                                  title: "市场基础投入",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group5_zxtrAuditAmount",
                              width: "100",
                              title: "专项投入",
                            },
                          }),
                          _vm.showColumn("gstctrzyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group5_gstctrzyAuditAmount",
                                  width: "100",
                                  title: "公司统筹投入(专用)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("blAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group5_blAuditAmount",
                                  width: "100",
                                  title: "B类费用",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("zrcsgjAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group5_zrcsgjAuditAmount",
                                  width: "100",
                                  title: "折让/厂商共建费用",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group5_trTotalAuditAmount",
                              width: "100",
                              title: "小计",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group5_ztAuditAmount",
                              width: "100",
                              title: "直投金额",
                            },
                          }),
                          _vm.showColumn("ztApplyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group5_jxsdfAuditAmount",
                                  width: "100",
                                  title: "经销商垫付金额",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showModule("group6")
                ? _c(
                    "vxe-colgroup",
                    {
                      attrs: {
                        title: "老绿瓶投入",
                        field: "group6",
                        "header-align": "center",
                      },
                    },
                    [
                      _vm.showColumn("zltrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group6_zltrAmount",
                              width: "100",
                              title: "战略投入",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("gstctrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group6_gstctrAmount",
                              width: "100",
                              title: "公司统筹投入",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("scjctrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group6_scjctrAmount",
                              width: "100",
                              title: "市场基础投入",
                            },
                          })
                        : _vm._e(),
                      _c("vxe-column", {
                        attrs: {
                          field: "group6_zxtrAmount",
                          width: "100",
                          title: "专项投入",
                        },
                      }),
                      _vm.showColumn("gstctrzyAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group6_gstctrzyAmount",
                              width: "100",
                              title: "公司统筹投入(专用)",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("blAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group6_blAmount",
                              width: "100",
                              title: "B类费用",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("zrcsgjAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group6_zrcsgjAmount",
                              width: "100",
                              title: "折让/厂商共建费用",
                            },
                          })
                        : _vm._e(),
                      _c("vxe-column", {
                        attrs: {
                          field: "group6_trTotalAmount",
                          width: "100",
                          title: "小计",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showModule("group7")
                ? _c(
                    "vxe-colgroup",
                    {
                      attrs: {
                        title: "老绿瓶系列",
                        field: "group7",
                        "header-align": "center",
                      },
                    },
                    [
                      _c("vxe-column", {
                        attrs: {
                          field: "group7_firstSubjectName",
                          width: "100",
                          title: "一级科目",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "group7_secondSubjectName",
                          width: "100",
                          title: "二级科目",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "group7_schemeAmout",
                          width: "100",
                          title: "方案规划金额",
                        },
                      }),
                      _c(
                        "vxe-colgroup",
                        {
                          attrs: {
                            title: "申请金额",
                            field: "group7-1",
                            "header-align": "center",
                          },
                        },
                        [
                          _vm.showColumn("zltrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group7_zltrApplyAmount",
                                  width: "100",
                                  title: "战略投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("gstctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group7_gstctrApplyAmount",
                                  width: "100",
                                  title: "公司统筹投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("scjctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group7_scjctrApplyAmount",
                                  width: "100",
                                  title: "市场基础投入",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group7_zxtrApplyAmount",
                              width: "100",
                              title: "专项投入",
                            },
                          }),
                          _vm.showColumn("gstctrzyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group7_gstctrzyApplyAmount",
                                  width: "100",
                                  title: "公司统筹投入(专用)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("blAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group7_blApplyAmount",
                                  width: "100",
                                  title: "B类费用",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("zrcsgjAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group7_zrcsgjApplyAmount",
                                  width: "100",
                                  title: "折让/厂商共建费用",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group7_trTotalApplyAmount",
                              width: "100",
                              title: "小计",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group7_applyRate",
                              width: "100",
                              title: "占比",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group7_ztApplyAmount",
                              width: "100",
                              title: "直投金额",
                            },
                          }),
                          _vm.showColumn("ztApplyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group7_jxsdfApplyAmount",
                                  width: "100",
                                  title: "经销商垫付金额",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("applyInvestRate")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group7_applyInvestRate",
                                  width: "100",
                                  title: "投入比(申请/投入)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("applyExecutionRate")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group7_applyExecutionRate",
                                  width: "100",
                                  title: "执行率(申请/规划)",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "vxe-colgroup",
                        {
                          attrs: {
                            title: "核销金额",
                            field: "group7-2",
                            "header-align": "center",
                          },
                        },
                        [
                          _vm.showColumn("zltrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group7_zltrAuditAmount",
                                  width: "100",
                                  title: "战略投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("gstctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group7_gstctrAuditAmount",
                                  width: "100",
                                  title: "公司统筹投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("scjctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group7_scjctrAuditAmount",
                                  width: "100",
                                  title: "市场基础投入",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group7_zxtrAuditAmount",
                              width: "100",
                              title: "专项投入",
                            },
                          }),
                          _vm.showColumn("gstctrzyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group7_gstctrzyAuditAmount",
                                  width: "100",
                                  title: "公司统筹投入(专用)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("blAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group7_blAuditAmount",
                                  width: "100",
                                  title: "B类费用",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("zrcsgjAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group7_zrcsgjAuditAmount",
                                  width: "100",
                                  title: "折让/厂商共建费用",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group7_trTotalAuditAmount",
                              width: "100",
                              title: "小计",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group7_ztAuditAmount",
                              width: "100",
                              title: "直投金额",
                            },
                          }),
                          _vm.showColumn("ztApplyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group7_jxsdfAuditAmount",
                                  width: "100",
                                  title: "经销商垫付金额",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showModule("group8")
                ? _c(
                    "vxe-colgroup",
                    {
                      attrs: {
                        title: "七彩投入",
                        field: "group8",
                        "header-align": "center",
                      },
                    },
                    [
                      _vm.showColumn("zltrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group8_zltrAmount",
                              width: "100",
                              title: "战略投入",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("gstctrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group8_gstctrAmount",
                              width: "100",
                              title: "公司统筹投入",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("scjctrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group8_scjctrAmount",
                              width: "100",
                              title: "市场基础投入",
                            },
                          })
                        : _vm._e(),
                      _c("vxe-column", {
                        attrs: {
                          field: "group8_zxtrAmount",
                          width: "100",
                          title: "专项投入",
                        },
                      }),
                      _vm.showColumn("gstctrzyAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group8_gstctrzyAmount",
                              width: "100",
                              title: "公司统筹投入(专用)",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("blAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group8_blAmount",
                              width: "100",
                              title: "B类费用",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("zrcsgjAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group8_zrcsgjAmount",
                              width: "100",
                              title: "折让/厂商共建费用",
                            },
                          })
                        : _vm._e(),
                      _c("vxe-column", {
                        attrs: {
                          field: "group8_trTotalAmount",
                          width: "100",
                          title: "小计",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showModule("group9")
                ? _c(
                    "vxe-colgroup",
                    {
                      attrs: {
                        title: "七彩系列",
                        field: "group9",
                        "header-align": "center",
                      },
                    },
                    [
                      _c("vxe-column", {
                        attrs: {
                          field: "group9_firstSubjectName",
                          width: "100",
                          title: "一级科目",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "group9_secondSubjectName",
                          width: "100",
                          title: "二级科目",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "group9_schemeAmout",
                          width: "100",
                          title: "方案规划金额",
                        },
                      }),
                      _c(
                        "vxe-colgroup",
                        {
                          attrs: {
                            title: "申请金额",
                            field: "group9-1",
                            "header-align": "center",
                          },
                        },
                        [
                          _vm.showColumn("zltrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group9_zltrApplyAmount",
                                  width: "100",
                                  title: "战略投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("gstctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group9_gstctrApplyAmount",
                                  width: "100",
                                  title: "公司统筹投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("scjctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group9_scjctrApplyAmount",
                                  width: "100",
                                  title: "市场基础投入",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group9_zxtrApplyAmount",
                              width: "100",
                              title: "专项投入",
                            },
                          }),
                          _vm.showColumn("gstctrzyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group9_gstctrzyApplyAmount",
                                  width: "100",
                                  title: "公司统筹投入(专用)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("blAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group9_blApplyAmount",
                                  width: "100",
                                  title: "B类费用",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("zrcsgjAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group9_zrcsgjApplyAmount",
                                  width: "100",
                                  title: "折让/厂商共建费用",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group9_trTotalApplyAmount",
                              width: "100",
                              title: "小计",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group9_applyRate",
                              width: "100",
                              title: "占比",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group9_ztApplyAmount",
                              width: "100",
                              title: "直投金额",
                            },
                          }),
                          _vm.showColumn("ztApplyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group9_jxsdfApplyAmount",
                                  width: "100",
                                  title: "经销商垫付金额",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("applyInvestRate")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group9_applyInvestRate",
                                  width: "100",
                                  title: "投入比(申请/投入)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("applyExecutionRate")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group9_applyExecutionRate",
                                  width: "100",
                                  title: "执行率(申请/规划)",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "vxe-colgroup",
                        {
                          attrs: {
                            title: "核销金额",
                            field: "group9-2",
                            "header-align": "center",
                          },
                        },
                        [
                          _vm.showColumn("zltrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group9_zltrAuditAmount",
                                  width: "100",
                                  title: "战略投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("gstctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group9_gstctrAuditAmount",
                                  width: "100",
                                  title: "公司统筹投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("scjctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group9_scjctrAuditAmount",
                                  width: "100",
                                  title: "市场基础投入",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group9_zxtrAuditAmount",
                              width: "100",
                              title: "专项投入",
                            },
                          }),
                          _vm.showColumn("gstctrzyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group9_gstctrzyAuditAmount",
                                  width: "100",
                                  title: "公司统筹投入(专用)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("blAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group9_blAuditAmount",
                                  width: "100",
                                  title: "B类费用",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("zrcsgjAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group9_zrcsgjAuditAmount",
                                  width: "100",
                                  title: "折让/厂商共建费用",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group9_trTotalAuditAmount",
                              width: "100",
                              title: "小计",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group9_ztAuditAmount",
                              width: "100",
                              title: "直投金额",
                            },
                          }),
                          _vm.showColumn("ztApplyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group9_jxsdfAuditAmount",
                                  width: "100",
                                  title: "经销商垫付金额",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showModule("group10")
                ? _c(
                    "vxe-colgroup",
                    {
                      attrs: {
                        title: "酒海投入",
                        field: "group10",
                        "header-align": "center",
                      },
                    },
                    [
                      _vm.showColumn("zltrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group10_zltrAmount",
                              width: "100",
                              title: "战略投入",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("gstctrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group10_gstctrAmount",
                              width: "100",
                              title: "公司统筹投入",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("scjctrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group10_scjctrAmount",
                              width: "100",
                              title: "市场基础投入",
                            },
                          })
                        : _vm._e(),
                      _c("vxe-column", {
                        attrs: {
                          field: "group10_zxtrAmount",
                          width: "100",
                          title: "专项投入",
                        },
                      }),
                      _vm.showColumn("gstctrzyAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group10_gstctrzyAmount",
                              width: "100",
                              title: "公司统筹投入(专用)",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("blAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group10_blAmount",
                              width: "100",
                              title: "B类费用",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("zrcsgjAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group10_zrcsgjAmount",
                              width: "100",
                              title: "折让/厂商共建费用",
                            },
                          })
                        : _vm._e(),
                      _c("vxe-column", {
                        attrs: {
                          field: "group10_trTotalAmount",
                          width: "100",
                          title: "小计",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showModule("group11")
                ? _c(
                    "vxe-colgroup",
                    {
                      attrs: {
                        title: "酒海系列",
                        field: "group11",
                        "header-align": "center",
                      },
                    },
                    [
                      _c("vxe-column", {
                        attrs: {
                          field: "group11_firstSubjectName",
                          width: "100",
                          title: "一级科目",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "group11_secondSubjectName",
                          width: "100",
                          title: "二级科目",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "group11_schemeAmout",
                          width: "100",
                          title: "方案规划金额",
                        },
                      }),
                      _c(
                        "vxe-colgroup",
                        {
                          attrs: {
                            title: "申请金额",
                            field: "group11-1",
                            "header-align": "center",
                          },
                        },
                        [
                          _vm.showColumn("zltrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group11_zltrApplyAmount",
                                  width: "100",
                                  title: "战略投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("gstctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group11_gstctrApplyAmount",
                                  width: "100",
                                  title: "公司统筹投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("scjctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group11_scjctrApplyAmount",
                                  width: "100",
                                  title: "市场基础投入",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group11_zxtrApplyAmount",
                              width: "100",
                              title: "专项投入",
                            },
                          }),
                          _vm.showColumn("gstctrzyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group11_gstctrzyApplyAmount",
                                  width: "100",
                                  title: "公司统筹投入(专用)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("blAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group11_blApplyAmount",
                                  width: "100",
                                  title: "B类费用",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("zrcsgjAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group11_zrcsgjApplyAmount",
                                  width: "100",
                                  title: "折让/厂商共建费用",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group11_trTotalApplyAmount",
                              width: "100",
                              title: "小计",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group11_applyRate",
                              width: "100",
                              title: "占比",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group11_ztApplyAmount",
                              width: "100",
                              title: "直投金额",
                            },
                          }),
                          _vm.showColumn("ztApplyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group11_jxsdfApplyAmount",
                                  width: "100",
                                  title: "经销商垫付金额",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("applyInvestRate")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group11_applyInvestRate",
                                  width: "100",
                                  title: "投入比(申请/投入)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("applyExecutionRate")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group11_applyExecutionRate",
                                  width: "100",
                                  title: "执行率(申请/规划)",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "vxe-colgroup",
                        {
                          attrs: {
                            title: "核销金额",
                            field: "group11-2",
                            "header-align": "center",
                          },
                        },
                        [
                          _vm.showColumn("zltrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group11_zltrAuditAmount",
                                  width: "100",
                                  title: "战略投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("gstctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group11_gstctrAuditAmount",
                                  width: "100",
                                  title: "公司统筹投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("scjctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group11_scjctrAuditAmount",
                                  width: "100",
                                  title: "市场基础投入",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group11_zxtrAuditAmount",
                              width: "100",
                              title: "专项投入",
                            },
                          }),
                          _vm.showColumn("gstctrzyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group11_gstctrzyAuditAmount",
                                  width: "100",
                                  title: "公司统筹投入(专用)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("blAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group11_blAuditAmount",
                                  width: "100",
                                  title: "B类费用",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("zrcsgjAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group11_zrcsgjAuditAmount",
                                  width: "100",
                                  title: "折让/厂商共建费用",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group11_trTotalAuditAmount",
                              width: "100",
                              title: "小计",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group11_ztAuditAmount",
                              width: "100",
                              title: "直投金额",
                            },
                          }),
                          _vm.showColumn("ztApplyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group11_jxsdfAuditAmount",
                                  width: "100",
                                  title: "经销商垫付金额",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showModule("group12")
                ? _c(
                    "vxe-colgroup",
                    {
                      attrs: {
                        title: "旗帜投入",
                        field: "group12",
                        "header-align": "center",
                      },
                    },
                    [
                      _vm.showColumn("zltrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group12_zltrAmount",
                              width: "100",
                              title: "战略投入",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("gstctrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group12_gstctrAmount",
                              width: "100",
                              title: "公司统筹投入",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("scjctrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group12_scjctrAmount",
                              width: "100",
                              title: "市场基础投入",
                            },
                          })
                        : _vm._e(),
                      _c("vxe-column", {
                        attrs: {
                          field: "group12_zxtrAmount",
                          width: "100",
                          title: "专项投入",
                        },
                      }),
                      _vm.showColumn("gstctrzyAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group12_gstctrzyAmount",
                              width: "100",
                              title: "公司统筹投入(专用)",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("blAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group12_blAmount",
                              width: "100",
                              title: "B类费用",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("zrcsgjAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group12_zrcsgjAmount",
                              width: "100",
                              title: "折让/厂商共建费用",
                            },
                          })
                        : _vm._e(),
                      _c("vxe-column", {
                        attrs: {
                          field: "group12_trTotalAmount",
                          width: "100",
                          title: "小计",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showModule("group13")
                ? _c(
                    "vxe-colgroup",
                    {
                      attrs: {
                        title: "旗帜系列",
                        field: "group13",
                        "header-align": "center",
                      },
                    },
                    [
                      _c("vxe-column", {
                        attrs: {
                          field: "group13_firstSubjectName",
                          width: "100",
                          title: "一级科目",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "group13_secondSubjectName",
                          width: "100",
                          title: "二级科目",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "group13_schemeAmout",
                          width: "100",
                          title: "方案规划金额",
                        },
                      }),
                      _c(
                        "vxe-colgroup",
                        {
                          attrs: {
                            title: "申请金额",
                            field: "group13-1",
                            "header-align": "center",
                          },
                        },
                        [
                          _vm.showColumn("zltrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group13_zltrApplyAmount",
                                  width: "100",
                                  title: "战略投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("gstctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group13_gstctrApplyAmount",
                                  width: "100",
                                  title: "公司统筹投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("scjctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group13_scjctrApplyAmount",
                                  width: "100",
                                  title: "市场基础投入",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group13_zxtrApplyAmount",
                              width: "100",
                              title: "专项投入",
                            },
                          }),
                          _vm.showColumn("gstctrzyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group13_gstctrzyApplyAmount",
                                  width: "100",
                                  title: "公司统筹投入(专用)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("blAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group13_blApplyAmount",
                                  width: "100",
                                  title: "B类费用",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("zrcsgjAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group13_zrcsgjApplyAmount",
                                  width: "100",
                                  title: "折让/厂商共建费用",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group13_trTotalApplyAmount",
                              width: "100",
                              title: "小计",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group13_applyRate",
                              width: "100",
                              title: "占比",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group13_ztApplyAmount",
                              width: "100",
                              title: "直投金额",
                            },
                          }),
                          _vm.showColumn("ztApplyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group13_jxsdfApplyAmount",
                                  width: "100",
                                  title: "经销商垫付金额",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("applyInvestRate")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group13_applyInvestRate",
                                  width: "100",
                                  title: "投入比(申请/投入)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("applyExecutionRate")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group13_applyExecutionRate",
                                  width: "100",
                                  title: "执行率(申请/规划)",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "vxe-colgroup",
                        {
                          attrs: {
                            title: "核销金额",
                            field: "group13-2",
                            "header-align": "center",
                          },
                        },
                        [
                          _vm.showColumn("zltrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group13_zltrAuditAmount",
                                  width: "100",
                                  title: "战略投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("gstctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group13_gstctrAuditAmount",
                                  width: "100",
                                  title: "公司统筹投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("scjctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group13_scjctrAuditAmount",
                                  width: "100",
                                  title: "市场基础投入",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group13_zxtrAuditAmount",
                              width: "100",
                              title: "专项投入",
                            },
                          }),
                          _vm.showColumn("gstctrzyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group13_gstctrzyAuditAmount",
                                  width: "100",
                                  title: "公司统筹投入(专用)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("blAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group13_blAuditAmount",
                                  width: "100",
                                  title: "B类费用",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("zrcsgjAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group13_zrcsgjAuditAmount",
                                  width: "100",
                                  title: "折让/厂商共建费用",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group13_trTotalAuditAmount",
                              width: "100",
                              title: "小计",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group13_ztAuditAmount",
                              width: "100",
                              title: "直投金额",
                            },
                          }),
                          _vm.showColumn("ztApplyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group13_jxsdfAuditAmount",
                                  width: "100",
                                  title: "经销商垫付金额",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showModule("group14")
                ? _c(
                    "vxe-colgroup",
                    {
                      attrs: {
                        title: "其他投入",
                        field: "group14",
                        "header-align": "center",
                      },
                    },
                    [
                      _vm.showColumn("zltrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group14_zltrAmount",
                              width: "100",
                              title: "战略投入",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("gstctrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group14_gstctrAmount",
                              width: "100",
                              title: "公司统筹投入",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("scjctrAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group14_scjctrAmount",
                              width: "100",
                              title: "市场基础投入",
                            },
                          })
                        : _vm._e(),
                      _c("vxe-column", {
                        attrs: {
                          field: "group14_zxtrAmount",
                          width: "100",
                          title: "专项投入",
                        },
                      }),
                      _vm.showColumn("gstctrzyAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group14_gstctrzyAmount",
                              width: "100",
                              title: "公司统筹投入(专用)",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("blAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group14_blAmount",
                              width: "100",
                              title: "B类费用",
                            },
                          })
                        : _vm._e(),
                      _vm.showColumn("zrcsgjAmount")
                        ? _c("vxe-column", {
                            attrs: {
                              field: "group14_zrcsgjAmount",
                              width: "100",
                              title: "折让/厂商共建费用",
                            },
                          })
                        : _vm._e(),
                      _c("vxe-column", {
                        attrs: {
                          field: "group14_trTotalAmount",
                          width: "100",
                          title: "小计",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showModule("group15")
                ? _c(
                    "vxe-colgroup",
                    {
                      attrs: {
                        title: "其他系列",
                        field: "group15",
                        "header-align": "center",
                      },
                    },
                    [
                      _c("vxe-column", {
                        attrs: {
                          field: "group15_firstSubjectName",
                          width: "100",
                          title: "一级科目",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "group15_secondSubjectName",
                          width: "100",
                          title: "二级科目",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "group15_schemeAmout",
                          width: "100",
                          title: "方案规划金额",
                        },
                      }),
                      _c(
                        "vxe-colgroup",
                        {
                          attrs: {
                            title: "申请金额",
                            field: "group15-1",
                            "header-align": "center",
                          },
                        },
                        [
                          _vm.showColumn("zltrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group15_zltrApplyAmount",
                                  width: "100",
                                  title: "战略投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("gstctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group15_gstctrApplyAmount",
                                  width: "100",
                                  title: "公司统筹投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("scjctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group15_scjctrApplyAmount",
                                  width: "100",
                                  title: "市场基础投入",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group15_zxtrApplyAmount",
                              width: "100",
                              title: "专项投入",
                            },
                          }),
                          _vm.showColumn("gstctrzyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group15_gstctrzyApplyAmount",
                                  width: "100",
                                  title: "公司统筹投入(专用)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("blAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group15_blApplyAmount",
                                  width: "100",
                                  title: "B类费用",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("zrcsgjAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group15_zrcsgjApplyAmount",
                                  width: "100",
                                  title: "折让/厂商共建费用",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group15_trTotalApplyAmount",
                              width: "100",
                              title: "小计",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group15_applyRate",
                              width: "100",
                              title: "占比",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group15_ztApplyAmount",
                              width: "100",
                              title: "直投金额",
                            },
                          }),
                          _vm.showColumn("ztApplyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group15_jxsdfApplyAmount",
                                  width: "100",
                                  title: "经销商垫付金额",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("applyInvestRate")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group15_applyInvestRate",
                                  width: "100",
                                  title: "投入比(申请/投入)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("applyExecutionRate")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group15_applyExecutionRate",
                                  width: "100",
                                  title: "执行率(申请/规划)",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "vxe-colgroup",
                        {
                          attrs: {
                            title: "核销金额",
                            field: "group15-2",
                            "header-align": "center",
                          },
                        },
                        [
                          _vm.showColumn("zltrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group15_zltrAuditAmount",
                                  width: "100",
                                  title: "战略投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("gstctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group15_gstctrAuditAmount",
                                  width: "100",
                                  title: "公司统筹投入",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("scjctrAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group15_scjctrAuditAmount",
                                  width: "100",
                                  title: "市场基础投入",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group15_zxtrAuditAmount",
                              width: "100",
                              title: "专项投入",
                            },
                          }),
                          _vm.showColumn("gstctrzyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group15_gstctrzyAuditAmount",
                                  width: "100",
                                  title: "公司统筹投入(专用)",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("blAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group15_blAuditAmount",
                                  width: "100",
                                  title: "B类费用",
                                },
                              })
                            : _vm._e(),
                          _vm.showColumn("zrcsgjAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group15_zrcsgjAuditAmount",
                                  width: "100",
                                  title: "折让/厂商共建费用",
                                },
                              })
                            : _vm._e(),
                          _c("vxe-column", {
                            attrs: {
                              field: "group15_trTotalAuditAmount",
                              width: "100",
                              title: "小计",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              field: "group15_ztAuditAmount",
                              width: "100",
                              title: "直投金额",
                            },
                          }),
                          _vm.showColumn("ztApplyAmount")
                            ? _c("vxe-column", {
                                attrs: {
                                  field: "group15_jxsdfAuditAmount",
                                  width: "100",
                                  title: "经销商垫付金额",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pagination.pageNum,
                  "page-sizes": [15, 20, 25],
                  "page-size": _vm.pagination.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.pagination.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "动态模块展示选择",
            visible: _vm.showModuleDialog,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showModuleDialog = $event
            },
            close: function ($event) {
              _vm.showModuleDialog = false
            },
          },
        },
        [
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.tempModuleChooseKey,
                callback: function ($$v) {
                  _vm.tempModuleChooseKey = $$v
                },
                expression: "tempModuleChooseKey",
              },
            },
            _vm._l(_vm.moduleOptions, function (item) {
              return _c(
                "el-checkbox",
                { key: item.value, attrs: { label: item.value } },
                [_vm._v(" " + _vm._s(item.label) + " ")]
              )
            }),
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleModuleCancel } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleModuleConfirm },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "动态参数展示选择",
            visible: _vm.showParamDialog,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showParamDialog = $event
            },
            close: function ($event) {
              _vm.showParamDialog = false
            },
          },
        },
        [
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.tempParamChooseKey,
                callback: function ($$v) {
                  _vm.tempParamChooseKey = $$v
                },
                expression: "tempParamChooseKey",
              },
            },
            _vm._l(_vm.paramOptions, function (item) {
              return _c(
                "el-checkbox",
                { key: item.value, attrs: { label: item.value } },
                [_vm._v(" " + _vm._s(item.label) + " ")]
              )
            }),
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleParamCancel } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleParamConfirm },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }